import { createSlice } from "@reduxjs/toolkit";
import cookies from "js-cookie";
import { getUserProfile, login } from "./thunk";

const initialState = {
  loggedinUser: {},
  rememberedUser: {},
  userProfile: {},
};

const slice = createSlice({
  name: "auth",
  initialState: { ...initialState },
  reducers: {
    logout: (state) => {
      state.loggedinUser = {};

      cookies.remove("userToken");
      cookies.remove("userId");
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(login.pending, () => {})
      .addCase(login.fulfilled, (state, action) => {
        const userDetails = action.payload?.data || {};
        state.loggedinUser = userDetails || {};
        state.rememberedUser = action.meta?.arg?.remember ? action.meta?.arg : {};

        cookies.set("userToken", userDetails.token);
        cookies.set("userId", userDetails.userId);
      })
      .addCase(login.rejected, () => {});
    builder
      .addCase(getUserProfile.pending, () => {})
      .addCase(getUserProfile.fulfilled, (state, action) => {
        state.userProfile = action.payload?.data || {};
      })
      .addCase(getUserProfile.rejected, () => {});
  },
});

export default slice.reducer;
export const { logout } = slice.actions;
